import { Capacitor } from '@capacitor/core';

/**
 * True when running inside the native Capacitor shell (Android/iOS app),
 * as opposed to a regular web browser. Safe to call in SSR/non-Capacitor
 * environments — falls back to false.
 */
export function isNativeApp() {
  try {
    return Capacitor.isNativePlatform();
  } catch (_) {
    return false;
  }
}

/**
 * Current platform: 'ios' | 'android' | 'web'.
 */
export function getPlatform() {
  try {
    return Capacitor.getPlatform();
  } catch (_) {
    return 'web';
  }
}
